

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { Api } from "../Api/Api";

// export default function BillingDetails() {
//   const [bills, setBills] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filter, setFilter] = useState("all");
//   const [customDate, setCustomDate] = useState("");

//   useEffect(() => {
//     axios
//       .get(`${Api}bills/get.php`)
//       .then((res) => {
//         if (res.data.ok) setBills(res.data.bills || []);
//         setLoading(false);
//       })
//       .catch(() => setLoading(false));
//   }, []);

//   // -----------------------
//   // Date helpers (DD-MM-YYYY)
//   // -----------------------
//   const pad = (n) => (n < 10 ? "0" + n : "" + n);
//   const toDMY = (dateObj) =>
//     dateObj
//       ? `${pad(dateObj.getDate())}-${pad(
//           dateObj.getMonth() + 1
//         )}-${dateObj.getFullYear()}`
//       : null;

//   const parseToLocalDate = (dateStr) => {
//     if (!dateStr) return null;
//     const d = new Date(dateStr);
//     return isNaN(d)
//       ? null
//       : new Date(d.getFullYear(), d.getMonth(), d.getDate());
//   };

//   const formatDate = (dateStrOrObj) => {
//     const d =
//       dateStrOrObj instanceof Date
//         ? dateStrOrObj
//         : parseToLocalDate(dateStrOrObj);
//     return d ? toDMY(d) : "";
//   };

//   // -----------------------
//   // Search + Filter
//   // -----------------------
//   const searchedBills = bills.filter((bill) => {
//     const s = searchTerm.trim().toLowerCase();
//     return (
//       !s ||
//       (bill.invoice_no || "").toLowerCase().includes(s) ||
//       (bill.buyer_name || "").toLowerCase().includes(s)
//     );
//   });

//   const getDateFilteredBills = () => {
//     if (filter === "all") return searchedBills;

//     return searchedBills.filter((bill) => {
//       const billDateObj = parseToLocalDate(bill.bill_date || bill.created_at);
//       if (!billDateObj) return false;

//       const today = new Date();
//       if (filter === "today") return toDMY(billDateObj) === toDMY(today);

//       if (filter === "yesterday") {
//         const y = new Date();
//         y.setDate(y.getDate() - 1);
//         return toDMY(billDateObj) === toDMY(y);
//       }

//       if (filter === "lastweek") {
//         const start = new Date();
//         start.setDate(start.getDate() - 7);
//         return billDateObj >= start;
//       }

//       if (filter === "lastmonth") {
//         const start = new Date();
//         start.setMonth(start.getMonth() - 1);
//         return billDateObj >= start;
//       }

//       if (filter === "custom" && customDate) {
//         const selected = parseToLocalDate(customDate);
//         return selected ? toDMY(billDateObj) === toDMY(selected) : false;
//       }
//       return true;
//     });
//   };

//   const filteredBills = getDateFilteredBills();

//   // -----------------------
//   // Total Paid Amount
//   // -----------------------
//   const totalPaidAmount = filteredBills.reduce(
//     (sum, bill) => sum + parseFloat(bill.paid_amount || 0),
//     0
//   );

//   // -----------------------
//   // PDF download
//   // -----------------------
//   const padFile = (s) =>
//     (s || "")
//       .toString()
//       .replace(/\s+/g, "_")
//       .replace(/[^a-zA-Z0-9_\-.]/g, "");

//   const getFilterLabel = () => {
//     if (filter === "all") return "All";
//     if (filter === "today") return `Today_${toDMY(new Date())}`;
//     if (filter === "yesterday") {
//       const y = new Date();
//       y.setDate(y.getDate() - 1);
//       return `Yesterday_${toDMY(y)}`;
//     }
//     if (filter === "lastweek") return "LastWeek";
//     if (filter === "lastmonth") return "LastMonth";
//     if (filter === "custom" && customDate) return `Custom_${customDate}`;
//     return filter;
//   };

//   const downloadPDF = () => {
//     const doc = new jsPDF("p", "pt");
//     doc.setFontSize(14);
//     doc.text("Billing Details Report", 40, 40);

//     const filterLabel = getFilterLabel();
//     doc.setFontSize(10);
//     doc.text(`Filter: ${filterLabel}`, 40, 58);
//     if (searchTerm) doc.text(`Search: ${searchTerm}`, 40, 74);
//     doc.text(`Generated: ${toDMY(new Date())}`, 40, 90);

//     const tableData = [];
//     filteredBills.forEach((bill, billIndex) => {
//       const items = bill.items || [];
//       items.forEach((item, itemIndex) => {
//         tableData.push([
//           itemIndex === 0 ? billIndex + 1 : "",
//           itemIndex === 0 ? bill.invoice_no : "",
//           itemIndex === 0 ? formatDate(bill.bill_date || bill.created_at) : "",
//           item.description || "",
//           item.hsn || "",
//           item.quantity || "",
//           item.rate || "",
//           itemIndex === 0 ? parseFloat(bill.subtotal || 0).toFixed(2) : "",
//           itemIndex === 0
//             ? bill.cgst_percent
//               ? `${bill.cgst_percent}%`
//               : ""
//             : "",
//           itemIndex === 0
//             ? bill.sgst_percent
//               ? `${bill.sgst_percent}%`
//               : ""
//             : "",
//           itemIndex === 0 ? parseFloat(bill.grand_total || 0).toFixed(2) : "",
//           itemIndex === 0 ? parseFloat(bill.paid_amount || 0).toFixed(2) : "",
//         ]);
//       });
//     });

//     autoTable(doc, {
//       head: [
//         [
//           "S.No",
//           "Invoice No",
//           "Date",
//           "Description",
//           "HSN",
//           "Qty",
//           "Rate",
//           "Subtotal",
//           "CGST",
//           "SGST",
//           "Grand Total",
//           "Paid Amount",
//         ],
//       ],
//       body: tableData,
//       startY: 110,
//       styles: { fontSize: 9, halign: "center", valign: "middle" },
//       headStyles: {
//         fillColor: [200, 200, 200],
//         textColor: [0, 0, 0],
//         lineWidth: 0.5,
//         lineColor: [0, 0, 0],
//       },
//       theme: "grid",
//     });

//     // Add total in last row (aligned with Paid Amount)
//     const finalY = doc.lastAutoTable.finalY || 110;
//     autoTable(doc, {
//       body: [
//         [
//           {
//             content: "Total Paid Amount",
//             colSpan: 11,
//             styles: { halign: "right" },
//           },
//           {
//             content: totalPaidAmount.toFixed(2),
//             styles: { halign: "right", fontStyle: "bold" },
//           },
//         ],
//       ],
//       startY: finalY + 5,
//       theme: "grid",
//       styles: { fontSize: 10 },
//     });

//     const fileName = `BillingDetails_${padFile(filterLabel)}${
//       searchTerm ? `_${padFile(searchTerm)}` : ""
//     }.pdf`;
//     doc.save(fileName);
//   };

//   if (loading) return <p className="text-center">Loading...</p>;

//   return (
//     <div className="p-6">
//       <h2 className="text-2xl font-semibold mb-4">Billing Details</h2>

//       {/* Search + Filters */}
//       <div className="flex flex-wrap gap-4 mb-4">
//         <input
//           type="text"
//           placeholder="Search Invoice No / Buyer Name"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           className="border px-3 py-2 rounded w-64"
//         />
//         <select
//           value={filter}
//           onChange={(e) => setFilter(e.target.value)}
//           className="border px-3 py-2 rounded"
//         >
//           <option value="all">All</option>
//           <option value="today">Today</option>
//           <option value="yesterday">Yesterday</option>
//           <option value="lastweek">Last Week</option>
//           <option value="lastmonth">Last Month</option>
//           <option value="custom">Custom Date</option>
//         </select>
//         {filter === "custom" && (
//           <input
//             type="date"
//             value={customDate}
//             onChange={(e) => setCustomDate(e.target.value)}
//             className="border px-3 py-2 rounded"
//           />
//         )}
//         <button
//           onClick={downloadPDF}
//           className="bg-blue-600 text-white px-4 py-2 rounded"
//         >
//           Download PDF
//         </button>
//       </div>

//       {/* Show Total */}
//       <div className="mb-4 font-semibold text-lg">
//         Total Paid Amount: {totalPaidAmount.toFixed(2)}
//       </div>

//       {/* Table */}
//       <div className="w-full overflow-x-auto">
//         <table className="min-w-[900px] border-collapse border border-gray-400 text-sm">
//           <thead>
//             <tr className="bg-gray-200">
//               <th className="border p-2">S.No</th>
//               <th className="border p-2">Invoice No</th>
//               <th className="border p-2">Date</th>
//               <th className="border p-2">Description</th>
//               <th className="border p-2">HSN</th>
//               <th className="border p-2">Quantity</th>
//               <th className="border p-2">Rate</th>
//               <th className="border p-2">Subtotal</th>
//               <th className="border p-2">CGST</th>
//               <th className="border p-2">SGST</th>
//               <th className="border p-2">Grand Total</th>
//               <th className="border p-2">Paid Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredBills.map((bill, billIndex) => (
//               <React.Fragment key={bill.id || billIndex}>
//                 {bill.items.map((item, itemIndex) => (
//                   <tr
//                     key={item.id || `${billIndex}-${itemIndex}`}
//                     className="bg-white"
//                   >
//                     {itemIndex === 0 && (
//                       <>
//                         <td className="border p-2" rowSpan={bill.items.length}>
//                           {billIndex + 1}
//                         </td>
//                         <td className="border p-2" rowSpan={bill.items.length}>
//                           {bill.invoice_no}
//                         </td>
//                         <td className="border p-2" rowSpan={bill.items.length}>
//                           {formatDate(bill.bill_date || bill.created_at)}
//                         </td>
//                       </>
//                     )}
//                     <td className="border p-2">{item.description}</td>
//                     <td className="border p-2">{item.hsn}</td>
//                     <td className="border p-2">{item.quantity}</td>
//                     <td className="border p-2">{item.rate}</td>
//                     <td className="border p-2" rowSpan={bill.items.length}>
//                       {bill.subtotal}
//                     </td>
//                     {itemIndex === 0 && (
//                       <>
//                         <td className="border p-2" rowSpan={bill.items.length}>
//                           {bill.cgst_percent ? `${bill.cgst_percent}%` : ""}
//                         </td>
//                         <td className="border p-2" rowSpan={bill.items.length}>
//                           {bill.sgst_percent ? `${bill.sgst_percent}%` : ""}
//                         </td>
//                         <td className="border p-2" rowSpan={bill.items.length}>
//                           {bill.grand_total}
//                         </td>
//                         <td className="border p-2" rowSpan={bill.items.length}>
//                           {bill.paid_amount}
//                         </td>
//                       </>
//                     )}
//                   </tr>
//                 ))}
//               </React.Fragment>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Api } from "../Api/Api";

export default function BillingDetails() {
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("all");
  const [customDate, setCustomDate] = useState("");

  useEffect(() => {
    axios
      .get(`${Api}bills/get.php`)
      .then((res) => {
        if (res.data.ok) setBills(res.data.bills || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  // Helpers
  const pad = (n) => (n < 10 ? "0" + n : "" + n);
  const toDMY = (dateObj) =>
    dateObj
      ? `${pad(dateObj.getDate())}-${pad(
          dateObj.getMonth() + 1
        )}-${dateObj.getFullYear()}`
      : "";

  const parseToLocalDate = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    return isNaN(d)
      ? null
      : new Date(d.getFullYear(), d.getMonth(), d.getDate());
  };

  const formatDate = (v) => {
    const d = v instanceof Date ? v : parseToLocalDate(v);
    return d ? toDMY(d) : "";
  };

  // Search Filter
  const searchedBills = bills.filter((bill) => {
    const s = searchTerm.trim().toLowerCase();
    return (
      !s ||
      bill.invoice_no?.toLowerCase().includes(s) ||
      bill.buyer_name?.toLowerCase().includes(s)
    );
  });

  // Date Filter
  const getDateFilteredBills = () => {
    if (filter === "all") return searchedBills;

    return searchedBills.filter((bill) => {
      const billDate = parseToLocalDate(bill.bill_date || bill.created_at);
      if (!billDate) return false;

      const today = new Date();

      if (filter === "today") return toDMY(billDate) === toDMY(today);

      if (filter === "yesterday") {
        const y = new Date();
        y.setDate(y.getDate() - 1);
        return toDMY(billDate) === toDMY(y);
      }

      if (filter === "lastweek") {
        const start = new Date();
        start.setDate(start.getDate() - 7);
        return billDate >= start;
      }

      if (filter === "lastmonth") {
        const start = new Date();
        start.setMonth(start.getMonth() - 1);
        return billDate >= start;
      }

      if (filter === "custom" && customDate) {
        const selected = parseToLocalDate(customDate);
        return toDMY(billDate) === toDMY(selected);
      }

      return true;
    });
  };

  const filteredBills = getDateFilteredBills();

  // Total Paid
  const totalPaidAmount = filteredBills.reduce(
    (sum, bill) => sum + parseFloat(bill.paid_amount || 0),
    0
  );

  // PDF Download
  const padFile = (s) =>
    (s || "")
      .toString()
      .replace(/\s+/g, "_")
      .replace(/[^a-zA-Z0-9_\-.]/g, "");

  const getFilterLabel = () => {
    if (filter === "all") return "All";
    if (filter === "today") return `Today_${toDMY(new Date())}`;
    if (filter === "yesterday") {
      const y = new Date();
      y.setDate(y.getDate() - 1);
      return `Yesterday_${toDMY(y)}`;
    }
    if (filter === "lastweek") return "LastWeek";
    if (filter === "lastmonth") return "LastMonth";
    if (filter === "custom" && customDate) return `Custom_${customDate}`;
    return filter;
  };

  const downloadPDF = () => {
    const doc = new jsPDF("p", "pt");
    doc.setFontSize(14);
    doc.text("Billing Details Report", 40, 40);

    doc.setFontSize(10);
    doc.text(`Filter: ${getFilterLabel()}`, 40, 58);
    if (searchTerm) doc.text(`Search: ${searchTerm}`, 40, 74);
    doc.text(`Generated: ${toDMY(new Date())}`, 40, 90);

    const tableData = [];

    filteredBills.forEach((bill, billIndex) => {
      bill.items.forEach((item, itemIndex) => {
        tableData.push([
          itemIndex === 0 ? billIndex + 1 : "",
          itemIndex === 0 ? bill.invoice_no : "",
          itemIndex === 0 ? formatDate(bill.bill_date || bill.created_at) : "",
          item.description,
          item.hsn,
          item.quantity,
          item.rate,
          itemIndex === 0 ? parseFloat(bill.subtotal).toFixed(2) : "",
          itemIndex === 0
            ? bill.cgst_percent
              ? bill.cgst_percent + "%"
              : ""
            : "",
          itemIndex === 0
            ? bill.sgst_percent
              ? bill.sgst_percent + "%"
              : ""
            : "",
          itemIndex === 0 ? parseFloat(bill.grand_total).toFixed(2) : "",
          itemIndex === 0 ? parseFloat(bill.paid_amount).toFixed(2) : "",
        ]);
      });
    });

    autoTable(doc, {
      head: [
        [
          "S.No",
          "Invoice No",
          "Date",
          "Description",
          "HSN",
          "Qty",
          "Rate",
          "Subtotal",
          "CGST",
          "SGST",
          "Grand Total",
          "Paid Amount",
        ],
      ],
      body: tableData,
      startY: 110,
      theme: "grid",
      styles: { fontSize: 9, halign: "center" },
      headStyles: { fillColor: [220, 220, 220] },
    });

    const finalY = doc.lastAutoTable.finalY;

    autoTable(doc, {
      startY: finalY + 8,
      body: [
        [
          {
            content: "Total Paid Amount",
            colSpan: 11,
            styles: { halign: "right" },
          },
          {
            content: totalPaidAmount.toFixed(2),
            styles: { fontStyle: "bold" },
          },
        ],
      ],
      theme: "grid",
    });

    doc.save(
      `BillingDetails_${padFile(getFilterLabel())}${
        searchTerm ? "_" + padFile(searchTerm) : ""
      }.pdf`
    );
  };

  if (loading) return <p className="text-center">Loading...</p>;

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">Billing Details</h2>

      {/* Filters */}
      <div className="flex flex-wrap gap-4 mb-4">
        <input
          type="text"
          placeholder="Search Invoice No / Buyer Name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border px-3 py-2 rounded w-64"
        />

        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="border px-3 py-2 rounded"
        >
          <option value="all">All</option>
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="lastweek">Last Week</option>
          <option value="lastmonth">Last Month</option>
          <option value="custom">Custom Date</option>
        </select>

        {filter === "custom" && (
          <input
            type="date"
            value={customDate}
            onChange={(e) => setCustomDate(e.target.value)}
            className="border px-3 py-2 rounded"
          />
        )}

        <button
          onClick={downloadPDF}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Download PDF
        </button>
      </div>

      {/* Total */}
      <div className="mb-4 font-semibold text-lg">
        Total Paid Amount: {totalPaidAmount.toFixed(2)}
      </div>

      {/* TABLE FIXED */}
      <div className="w-full overflow-x-auto">
        <table className="min-w-[900px] border-collapse border border-gray-400 text-sm">
          <thead>
            <tr className="bg-gray-200">
              <th className="border p-2">S.No</th>
              <th className="border p-2">Invoice No</th>
              <th className="border p-2">Date</th>
              <th className="border p-2">Description</th>
              <th className="border p-2">HSN</th>
              <th className="border p-2">Quantity</th>
              <th className="border p-2">Rate</th>
              <th className="border p-2">Subtotal</th>
              <th className="border p-2">CGST</th>
              <th className="border p-2">SGST</th>
              <th className="border p-2">Grand Total</th>
              <th className="border p-2">Paid Amount</th>
            </tr>
          </thead>

          <tbody>
            {filteredBills.map((bill, billIndex) => (
              <React.Fragment key={bill.id || billIndex}>
                {bill.items.map((item, itemIndex) => (
                  <tr key={item.id || `${billIndex}-${itemIndex}`}>
                    {itemIndex === 0 && (
                      <>
                        <td className="border p-2" rowSpan={bill.items.length}>
                          {billIndex + 1}
                        </td>
                        <td className="border p-2" rowSpan={bill.items.length}>
                          {bill.invoice_no}
                        </td>
                        <td className="border p-2" rowSpan={bill.items.length}>
                          {formatDate(bill.bill_date || bill.created_at)}
                        </td>
                      </>
                    )}

                    {/* Item Columns */}
                    <td className="border p-2">{item.description}</td>
                    <td className="border p-2">{item.hsn}</td>
                    <td className="border p-2">{item.quantity}</td>
                    <td className="border p-2">{item.rate}</td>

                    {/* FIX: These 5 columns should appear ONLY once */}
                    {itemIndex === 0 && (
                      <>
                        <td className="border p-2" rowSpan={bill.items.length}>
                          {bill.subtotal}
                        </td>
                        <td className="border p-2" rowSpan={bill.items.length}>
                          {bill.cgst_percent ? bill.cgst_percent + "%" : ""}
                        </td>
                        <td className="border p-2" rowSpan={bill.items.length}>
                          {bill.sgst_percent ? bill.sgst_percent + "%" : ""}
                        </td>
                        <td className="border p-2" rowSpan={bill.items.length}>
                          {bill.grand_total}
                        </td>
                        <td className="border p-2" rowSpan={bill.items.length}>
                          {bill.paid_amount}
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
